import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import ATCLogo from 'images/atc.svg';

import { socialLinks, indexSolutions } from 'utils/contentProvider';

import {
  HeaderContainer,
  MenuButton,
  MegaMenu,
  CTAButton,
  LogoContainer,
} from './Header.styled';

const Header = ({ lightTheme, path, blackMenuButton, isScollTop, style }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const closeMenuOnClick = () => {
    setMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    if (document) {
      // document.body.style.overflow = isMenuOpen ? 'hidden' : 'auto';
    }
  }, [isMenuOpen]);

  return (
    <>
      {/* <MenuButton
        type="button"
        className={`menu-trigger center${blackMenuButton ? ' black' : ''}`}
        onClick={() => setMenuOpen(!isMenuOpen)}
        style={
          isMenuOpen ? { backgroundColor: '#ffffff', color: '#000000' } : {}
        }
      >
        {isMenuOpen ? 'Close' : 'Menu'}
      </MenuButton> */}
      <HeaderContainer
        isMenuOpen={isMenuOpen}
        isScollTop={isScollTop}
        style={style}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-4">
              <LogoContainer path={path} className="menu-logo">
                <Link to="https://atc.xyz/">
                  <ATCLogo
                    width="72px"
                    className="img-responsive"
                    fill={isMenuOpen || !lightTheme ? '#ffffff' : '#000000'}
                    style={{ transition: 'all 0.2s ease-in-out' }}
                  />
                </Link>
              </LogoContainer>
            </div>
            <div className="col-md-6 col-8" style={{ position: 'relative' }}>
              {path.startsWith('/checkout') ||
              path.startsWith('/atc-ventures') ? (
                <span />
              ) : (
                <CTAButton
                  to="https://atc.xyz/contact-us/"
                  active={isMenuOpen}
                  lightTheme={lightTheme}
                >
                  Estimate Project
                </CTAButton>
              )}
            </div>
          </div>
        </div>
      </HeaderContainer>
      <MegaMenu className={`menu-nav-main${isMenuOpen ? ' show' : ''}`}>
        <div className="container">
          <div className="main-menu-nav">
            <div className="row">
              <div className="col-md-3">
                <ul className="nav-main-links">
                  <li className={path === '/about-us/' ? 'active' : ''}>
                    <Link to="/about-us/" onClick={() => closeMenuOnClick()}>
                      About
                    </Link>
                  </li>
                  <li className={path === '/careers/' ? 'active' : ''}>
                    <Link to="/careers/" onClick={() => closeMenuOnClick()}>
                      Careers
                    </Link>
                  </li>
                  <li
                    className={path.startsWith('/solutions/') ? 'active' : ''}
                  >
                    <Link to="/solutions/" onClick={() => closeMenuOnClick()}>
                      Solutions
                    </Link>
                  </li>
                  <li
                    className={
                      path.startsWith('/atc-ventures/') ? 'active' : ''
                    }
                  >
                    <Link
                      to="/atc-ventures/"
                      onClick={() => closeMenuOnClick()}
                    >
                      Ventures
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-3">
                <ul className="nav-main-links">
                  <li
                    className={path.startsWith('/trainings/') ? 'active' : ''}
                  >
                    <Link to="/trainings/" onClick={() => closeMenuOnClick()}>
                      Training
                    </Link>
                  </li>
                  <li className={path === '/contact-us/' ? 'active' : ''}>
                    <Link to="/contact-us/" onClick={() => closeMenuOnClick()}>
                      Contact
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-6 col-6">
                    <h4 className="nav-head">Our Solutions</h4>
                    <ul className="nav-side-links">
                      {indexSolutions.map((i) => (
                        <li key={i.title}>
                          <a href={i.link}>{i.title}</a>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-6 col-6">
                    <h4 className="nav-head">Our Resources</h4>
                    <ul className="nav-side-links">
                      <li>
                        <a href="https://blog.american-technology.net/">Blog</a>
                      </li>
                      <li>
                        <a href="https://blog.american-technology.net/videos/">
                          Videos
                        </a>
                      </li>
                      <li>
                        <a href="https://blog.american-technology.net/webinars/">
                          Webinars
                        </a>
                      </li>
                      <li>
                        <a href="https://blog.american-technology.net/whitepapers/">
                          Whitepapers
                        </a>
                      </li>
                    </ul>
                    <h4 className="nav-head" style={{ marginTop: 100 }}>
                      Social
                    </h4>
                    <ul className="nav-social-links">
                      <li>
                        <a
                          href={socialLinks.facebook}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={socialLinks.twitter}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-twitter"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={socialLinks.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-linkedin-in"></i>
                        </a>
                      </li>
                      <li>
                        <a
                          href={socialLinks.youtube}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="fab fa-youtube"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MegaMenu>
    </>
  );
};

Header.propTypes = {
  lightTheme: PropTypes.bool,
  path: PropTypes.string.isRequired,
  blackMenuButton: PropTypes.bool,
  isScollTop: PropTypes.bool,
  style: PropTypes.object,
};

export default Header;
